import styled from 'styled-components';

import {
  textSize,
  touchTarget,
  brand,
  ink,
  surface,
  tones,
} from '../../../../styles/brand';
export const TabRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid ${surface.line};
  margin-bottom: 1.5rem;
`;

export const Tab = styled.button<{ $active: boolean }>`
  background: none;
  border: none;
  padding: 0.6rem 1rem;
  font-family: 'RedHatDisplay-Bold';
  font-size: ${textSize(0.95)};
  cursor: pointer;
  color: ${props => (props.$active ? ink : tones.gray.text)};
  border-bottom: 2.5px solid
    ${props => (props.$active ? brand.orange : 'transparent')};
  margin-bottom: -1px;
  transition:
    color 0.2s,
    border-color 0.2s;

  &:hover {
    color: ${ink};
  }
`;

export const DownloadLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.9)};
  color: ${brand.blue};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const BatchActionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 0.8rem;
`;

export const AddMediaButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  border: 1px solid ${surface.line};
  border-radius: 0.5rem;
  background: #fff;
  padding: 0.5rem 1rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.9)};
  color: ${ink};
  cursor: pointer;
  transition: border-color 0.2s;

  &:hover {
    border-color: ${brand.orange};
  }
`;

export const FormRow = styled.div`
  width: 100%;
  display: flex;
  gap: 0.7rem;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;

  /* Cartão estreito: três campos lado a lado cortavam o texto ("Selecior",
     "Ano e…"). O primeiro campo ganha a linha toda e os outros dividem a
     de baixo. */
  @container (max-width: 460px) {
    > :first-child {
      flex: 1 1 100%;
    }
  }
`;

export const FieldGroup = styled.div<{ $flex?: number }>`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  flex: ${props => props.$flex ?? 1};
  min-width: 0;
`;

export const FieldLabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FieldLabel = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.82)};
  color: ${tones.gray.text};
`;

export const FieldHint = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.78)};
  color: ${tones.red.text};
`;

export const PlainInput = styled.input`
  width: 100%;
  height: 3.05rem;
  border: 0.5px solid ${surface.line};
  border-radius: 0.56rem;
  padding: 0 0.8rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(1)};
  color: ${ink};
  background: #fff;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;

  &:focus {
    border-color: ${brand.orange};
  }

  &::placeholder {
    color: #aaa;
  }
`;

export const SelectBox = styled.select`
  width: 100%;
  height: 3.05rem;
  border: 0.5px solid ${surface.line};
  border-radius: 0.56rem;
  padding: 0 0.8rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(1)};
  color: ${ink};
  background: #fff;
  outline: none;
  cursor: pointer;
  transition: border-color 0.2s;

  &:focus {
    border-color: ${brand.orange};
  }
`;

export const SelectedChipBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3.05rem;
  border: 0.5px solid ${surface.line};
  border-radius: 0.56rem;
  padding: 0 0.8rem;
  background: #fff;
  gap: 0.5rem;
  box-sizing: border-box;
`;

export const SelectedChipText = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(1)};
  color: ${ink};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ClearChipButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${tones.gray.text};
  flex-shrink: 0;
  transition: color 0.2s;

  &:hover {
    color: ${tones.red.text};
  }
`;

export const AlunosRow = styled.div`
  display: flex;
  min-height: 3.05rem;
  flex-direction: column;
  gap: 0.8rem;
  align-items: flex-start;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`;

export const StudentInputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 3.05rem;
  border: 0.5px solid ${surface.line};
  border-radius: 0.56rem;
  background: #fff;
  overflow: hidden;
  min-width: 160px;
  flex-shrink: 0;
`;

export const StudentInput = styled.input`
  flex: 1;
  height: 100%;
  border: none;
  outline: none;
  padding: 0 0.8rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.95)};
  color: ${ink};
  background: transparent;

  &::placeholder {
    color: #aaa;
  }
`;

export const StudentInputArrow = styled.button`
  height: 100%;
  width: 2.4rem;
  min-width: ${touchTarget};
  min-height: ${touchTarget};
  border-radius: 0.55rem;
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${brand.blue};
  flex-shrink: 0;
  transition: background 0.2s;

  @media (hover: hover) {
    &:hover {
      background: rgba(30, 136, 229, 0.06);
    }
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;

export const ChipsRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const StudentChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: #fff;
  border: 1px solid ${tones.blue.border};
  border-radius: 2rem;
  padding: 0.3rem 0.75rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.85)};
  color: ${ink};
  height: 3.05rem;
`;

export const ChipRemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  color: ${tones.gray.text};
  line-height: 1;
  transition: color 0.2s;

  &:hover {
    color: ${tones.red.text};
  }
`;

export const SaveRowButton = styled.button`
  align-self: flex-end;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: ${brand.orange};
  border: none;
  border-radius: 0.56rem;
  padding: 0 1.4rem;
  height: 3.05rem;
  font-family: 'RedHatDisplay-Bold';
  font-size: ${textSize(0.95)};
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;

  &:hover {
    background: #e68900;
  }

  &:disabled {
    background: #f5c87a;
    cursor: not-allowed;
  }
`;

export const SecondaryRowButton = styled.button`
  align-self: flex-end;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: #fff;
  border: 1px solid ${surface.line};
  border-radius: 0.56rem;
  padding: 0 1.2rem;
  height: 3.05rem;
  font-family: 'RedHatDisplay-Bold';
  font-size: ${textSize(0.95)};
  color: ${tones.gray.text};
  cursor: pointer;
  white-space: nowrap;
  transition:
    border-color 0.2s,
    color 0.2s,
    background 0.2s;

  &:hover {
    border-color: #a8a8a8;
    color: ${ink};
    background: ${surface.page};
  }

  &:disabled {
    color: ${tones.gray.text};
    border-color: ${surface.line};
    background: ${surface.page};
    cursor: not-allowed;
  }
`;

export const TeamsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 1.5rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.82)};

  th {
    background: #f5f5f5;
    color: ${tones.gray.text};
    text-align: left;
    padding: 0.6rem 0.8rem;
    font-weight: 600;
    border-bottom: 1px solid ${surface.line};
  }

  td {
    padding: 0.55rem 0.8rem;
    color: ${ink};
    border-bottom: 1px solid #f0f0f0;
  }

  tr:last-child td {
    border-bottom: none;
  }

  tr:hover td {
    background: ${surface.page};
  }
`;
